import { useEffect, useRef } from "react";
import Lenis from "lenis";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Countdown from "@/components/site/Countdown";
import About from "@/components/site/About";
import Marquee from "@/components/site/Marquee";
import Camps from "@/components/site/Camps";
import Booking from "@/components/site/Booking";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";

export default function HomePage() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  const scrollTo = (target) => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(target, { offset: -20 });
    }
  };

  return (
    <>
      <Navbar onNavigate={scrollTo} />
      <main>
        <Hero onNavigate={scrollTo} />
        <Countdown onNavigate={scrollTo} />
        <About />
        <Marquee />
        <Camps onNavigate={scrollTo} />
        <Booking />
        <Gallery />
        <Testimonials />
        <Contact />
      </main>
    </>
  );
}
